<div id="tab-rankings" class="d-flex flex-column flex-grow-1 gap-2">
    <div id="tab-rankings-header" class="d-flex align-items-center justify-content-between gap-2">
        <nav class="flex-grow-1" style="min-width: 0;">
            <ul class="nav nav-underline flex-nowrap overflow-auto">
            </ul>
        </nav>
        <div class="d-flex flex-row align-items-center gap-2">
            <button id="btn-table-settings" class="btn btn-sm btn-secondary">Table settings</button>
            <button id="btn-add-table" class="btn btn-sm btn-primary">Add table</button>
        </div>
    </div>
    <div id="table-view" class="flex-grow-1 overflow-auto"">
    </div>
</div>